import { IzIntegrationWebComponent } from './component/IzIntegrationWebComponent';
import { WEB_COMPONENT_IZ_INTEGRATION } from '../webcomponents.constants';

export { IzIntegrationWebComponent };

window.customElements.define(WEB_COMPONENT_IZ_INTEGRATION, IzIntegrationWebComponent);
